import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { findByIdInTreeList, findInTreeList } from "../../utils/tree";
import { isNullOrUndefined } from "../../utils/todo-utils";
import { DragDropContext, Droppable } from 'react-beautiful-dnd'
import { onEditModalDragEndFunction } from "../../functions/dragFunctions/dragFunctions";
import "./EditModal.css";
import { editTaskInFirebase } from "../../redux/actions/TodoManipulation/editTaskInFirebaseAction";
import { createFilterCanSeeAction, getfilterSetCanSeeCompletedActionType } from "../../redux/actions/filterAction";
import { getFilterState } from "../../functions/filterState/filterState";
import { changeColorOfTask } from "../../redux/actions/TodoManipulation/changeColorAction";
import { RecurrencePeriodEnum } from "../../models/recurrence-period";
import { bulkEditTaskInFirebase } from "../../redux/actions/TodoManipulation/bulkEditAction";
import axios from "../../api/axiosConfig";
import LoadingScreen from "../loadingScreen/LoadingScreen";
import AiModalComponent from "../aiModal/AiModalComponent";
import AiMessageModalComponent from "../aiMessageModal/AiMessageModal";
import MoveTaskToNewParent from "../moveTaskToProjectModal/moveTaskToNewParent";
import { getTheme } from "../../functions/themeService/themeService";
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import DatePickerModalComponent from "../datePickerModal/datePickerModal";
import dayjs from "dayjs";
import TaskSizeButton from "./TaskSizeButton";
import Comments from "./Comments";
import { addCommentToTask } from "../../redux/actions/TodoManipulation/addCommentAction";
import { aiTasksToFirebaseAction } from "../../redux/actions/TodoManipulation/aiTasksToFirebaseAction";
import AddSubTask from "./AddSubTask";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import DeleteModal from "./DeleteModal";
import { deleteTaskFromFirebase } from "../../redux/actions/TodoManipulation/deleteTaskFromFirebaseAction";
import TaskList from "./SubTasks";
import MessageModal from "../messageModal/MessageModal";
import { setDateTime } from "../../redux/actions/setDateTimeAction";
import { useIsMobile } from "../../functions/deviceIdentity/getDeviceType";
import EditModalHeader from "./EditModalHeader";

const EditModal = () => {
    const ref = useRef();
    const closeModalRef = useRef(null);
    const feature = "Overview";
    const filterStateName = getFilterState(feature) ?? "overviewFilterState";
    const [title, setTitle] = useState("");
    const [todoId, setTodoId] = useState("");
    const [parentRef, setParentRef] = useState("");
    const [description, setDescription] = useState(null);
    const [addItemMode, setAddItemMode] = useState(false);
    const [isCompleted, setIsCompleted] = useState(false);
    const [todoColor, setTodoColor] = useState("");
    const [comment, setComment] = useState("");
    const [todoType, setTodoType] = useState(null);
    const [parents, setParents] = useState([]);
    const [isProject, setIsProject] = useState(false);
    const [children, setChildren] = useState([]);
    const [dueDate, setDueDate] = useState(null);
    const [notificationDate, setNotificationDate] = useState(null);
    const [snoozedUntil, setSnoozedUntil] = useState(null);
    const [visualSize, setVisualSize] = useState(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [recurrence, setRecurrence] = useState('');
    const [recurrenceName, setRecurrenceName] = useState('');
    const dispatch = useDispatch();
    const theme = getTheme();
    const projects = useSelector((state) => state.taskList.data);
    const showCompleted = useSelector((state) => state[filterStateName].CanSeeCompleted);
    const aiAssistant = useSelector((state) => state.userSettings.aiAssistant);
    const showTaskProgress = useSelector((state) => state.userSettings.showTaskProgress);
    const [showAiModal, setShowAiModal] = useState(false);
    const [showMoveTo, setShowMoveTo] = useState(false);
    const [showError, setShowError] = useState(false);
    const selectedDate = useSelector((state) => state.selectedDate.date);
    const aiTasks = useSelector((state) => state.addAiTasks.tasks);
    const [errorMsg, setErrorMsg] = useState('');
    const { todoid } = useParams();
    let todo = useSelector((state) => state.showEditModal);
    const [addTodo, setAddTodo] = useState({
        isCompleted: false, type: 0, parent: null,
        title: '', description: '', dueDate: '', notificationDate: '',
        snoozedUntil: '', color: '', recurrence: '', visualSize: 0,
        hasNotification: false, hasSnoozedUntil: false, hasDueDate: false,
        hasDescription: false, parentId: '', subTasksToAdd: [], commentsToAdd: []
    });
    const [content, setContent] = useState("");
    const [disableButtons, setDisableButtons] = useState(true);
    const [modalOpenDate, setModalOpenDate] = useState('');
    const [dateType, setDateType] = useState('');
    const [showDateModal, setShowDateModal] = useState(false);
    const textareaClass = theme === "light" ? "light-textarea" : "dark-textarea";

    const [showAiMessageModal, setShowAiMessageModal] = useState(false);
    const [isHovered, setIsHovered] = useState(false);

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showMessageModal, setShowMessageModal] = useState(false);
    const [messageText, setMessageText] = useState('');
    const [isSubtasksExpanded, setIsSubtasksExpanded] = useState(false);
    const [isAddSubtasksShowing, setIsAddSubtasksShowing] = useState(false);
    const [showSubTaskAccordion, setShowSubTaskAccordion] = useState(false);
    const [showSubTaskButton, setShowSubTaskButton] = useState(false);

    const [showCompletedTasks, setShowCompletedtasks] = useState(false);

    const blankGUID = '00000000-0000-0000-0000-000000000000';
    const [newParentId, setNewParentId] = useState('');

    const [comments, setComments] = useState([]);
    const [isCommentsExpanded, setIsCommentsExpanded] = useState(false);
    const [isAddCommentsShowing, setIsAddCommentsShowing] = useState(false);
    const [showCommentsAccordion, setShowCommentsAccordion] = useState(false);
    const [showCommentButton, setShowCommentButton] = useState(false);
    const [isShowDetailsExpanded, setIsShowDetailsExpanded] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    const isMobile = useIsMobile();

    const handleAddComment = async (newComment) => {
        if (addItemMode) {
            const c = {
                id: (Math.floor(Math.random() * 9000) + 1000).toString(),
                text: newComment
            };
            setAddTodo({
                ...addTodo,
                commentsToAdd: addTodo.commentsToAdd ? addTodo.commentsToAdd.concat(c) : c
            });
            setComments(addTodo.commentsToAdd.concat(c))
        } else {
            const json = {

                id: todo.id,
                text: newComment
            }

            await dispatch(addCommentToTask(json));
        }
        const inputElement = document.querySelector(".add-comment-title");
        if (inputElement) {
            inputElement.focus();
        }
    };

    const handleAddTask = (textContent) => {
        if (addItemMode) {
            const c = {
                id: (Math.floor(Math.random() * 9000) + 1000).toString(),
                title: textContent
            };
            setAddTodo({
                ...addTodo,
                subTasksToAdd: addTodo.subTasksToAdd ? addTodo.subTasksToAdd.concat(c) : c
            });
            setChildren(addTodo.subTasksToAdd ? addTodo.subTasksToAdd.concat(c) : c);
        } else {
            let subTasks = [];

            subTasks.push(textContent);

            const json = {
                parentId: todo.id,
                todoTitle: todo.title,
                subTaskTitles: subTasks,
                newTodo: false
            }

            dispatch(aiTasksToFirebaseAction(json));
        }
        const inputElement = document.querySelector(".add-task-title");
        if (inputElement) {
            inputElement.focus();
        }
    };

    const handleSubtasksToggle = () => {
        setIsSubtasksExpanded(!isSubtasksExpanded);
    };

    const handleShowDetailsToggle = () => {
        setIsShowDetailsExpanded(!isShowDetailsExpanded);
    }

    const toggleCompletedTasks = () => {
        setShowCompletedtasks(!showCompletedTasks);
    }

    const handleCommentsToggle = () => {
        setIsCommentsExpanded(!isCommentsExpanded);
    };

    const handleAddCommentToggle = () => {
        setIsAddCommentsShowing(!isAddCommentsShowing);
    }

    const handleCommentAccordionToggle = () => {
        setShowCommentsAccordion(true);
        setShowCommentButton(false);
        setIsCommentsExpanded(true);
        setIsAddCommentsShowing(true);
    }

    const handleCommentDisplay = () => {
        let comments = 0;
        if (addItemMode) {
            comments = addTodo.commentsToAdd.length;
        } else {
            comments = todo.comments.length;
        }

        if (comments > 0) {
            setShowCommentButton(false);
            setShowCommentsAccordion(true);

        }
        else {
            setShowCommentButton(true);
            setShowCommentsAccordion(false);
        }
    }

    const handleAddSubTaskToggle = () => {
        setIsAddSubtasksShowing(!isAddSubtasksShowing);
    };

    const handleSubTaskAccordionToggle = () => {
        setShowSubTaskAccordion(true);
        setShowSubTaskButton(false);
        setIsSubtasksExpanded(true);
        setIsAddSubtasksShowing(true);
    };

    const handleAddTaskChange = (event) => {
        if (event.key === 'Enter') {
            const title = event.target.value;
            if (title !== "") {
                handleAddTask(title);
                setContent("");
            }
        }
        else if (event.key === 'Escape') {
            setContent("");
            setIsAddSubtasksShowing(parent.$id);
        }
        else {
            if (event.key !== 'Enter') {
                setContent(event.target.value);
            }
        }

        if (event.target.value) {
            setDisableButtons(false);
        } else {
            setDisableButtons(true);
        }

    };

    const countCompletedTasks = (parent) => {
        let totalTasks = 0;
        let completedTasks = 0;

        if (addItemMode) {
            return `0/${addTodo.subTasksToAdd ? addTodo.subTasksToAdd.length : 0}`;
        }

        if (parent.children && parent.children.length > 0) {
            for (var child of parent.children) {
                totalTasks++;
                if (child.isCompleted) {
                    completedTasks++;
                }
            }
        }
        const returnValue = `${completedTasks}/${totalTasks}`;
        return returnValue;
    }


    const handleSubTaskDisplay = () => {
        let children = 0;

        if (addItemMode) {
            children = addTodo.subTasksToAdd ? addTodo.subTasksToAdd.length : [];
        } else {
            children = todo.children.length;
        }

        if (children > 0) {
            setShowSubTaskButton(false);
            setShowSubTaskAccordion(true);
            setIsSubtasksExpanded(true);
        }
        else {
            setShowSubTaskButton(true);
            setShowSubTaskAccordion(false);
            setIsSubtasksExpanded(false);
        }
    }

    const handleAddNewTask = async () => {

        if (addTodo.title.length === 0) {
            setErrorMsg("* Please add a title");
            setShowError(true);
            return;
        }

        const subTaskTitles = addTodo.subTasksToAdd ? addTodo.subTasksToAdd.map(subTask => subTask.title) : [];
        const commentTitles = addTodo.commentsToAdd ? addTodo.commentsToAdd.map(comment => comment.text) : [];

        const json = {
            "id": blankGUID,
            "detailsChanged": {
                "detailsChange": {
                    Title: addTodo.title,
                    IsCompleted: addTodo.isCompleted,
                    HasDescription: (addTodo.description ? true.toString() : false.toString()),
                    Description: addTodo.description,
                    HasDueDate: (addTodo.dueDate ? true.toString() : false.toString()),
                    DueDate: addTodo.dueDate,
                    VisualSize: addTodo.visualSize,
                    HasSnoozedUntil: (addTodo.snoozedUntil ? true.toString() : false.toString()),
                    SnoozedUntil: addTodo.snoozedUntil,
                },
                "ColorChange": {
                    Color: (addTodo.color ? addTodo.color : '#80C3E9'),
                },
                "NotificationDateChange": {
                    AbsoluteDate: addTodo.notificationDate
                },
                "recurrenceChange": {
                    "recurrencePattern": {
                        "period": recurrence
                    },
                    deleteAnyFutureIncompleteTasksIfNecessary: false
                },
                "ParentChange": {
                    ParentId: newParentId,
                },
                "CommentsToAdd": commentTitles,
                "SubtasksToAdd": subTaskTitles
            }
        };

        await dispatch(bulkEditTaskInFirebase(json));

        setAddItemMode(false);
        closeModal();
    };

    const getParents = (todo) => {
        let currentTodo = todo;
        const tempParents = [];
        while (currentTodo.parent) {
            let parent = findInTreeList(projects, found => found.$id === currentTodo.parent.$ref);
            if (parent) {
                tempParents.unshift(parent);
                currentTodo = parent;

            } else { break; }

        }
        setParents(tempParents);
    };

    const handleDragEnd = (result) => {
        onEditModalDragEndFunction(todo, projects, result, dispatch, showCompletedTasks);
    };

    const handleDescriptionChange = (value) => {
        if (addItemMode) {
            setAddTodo({
                ...addTodo,
                description: value
            });
        }

        if (value !== description) {
            setDescription(value);
        }
    };

    const closeModal = () => {
        if (addItemMode) {
            setAddItemMode(false);
        }

        updateDescription(description);
        setIsCompleted(false);
        setTitle("");
        setDescription(null);
        setTodoColor("");
        setTodoId("");
        setParents([]);
        setParentRef("");
        setChildren([]);
        setTodoType(null);
        setDueDate(null);
        setNotificationDate(null);
        setSnoozedUntil(null);
        setIsModalVisible(false);
        setComments([]);
        setRecurrence('');
        setRecurrenceName('Never');

        setVisualSize('');
        setAddTodo({
            isCompleted: false, type: 0, parent: null,
            title: '', description: '', dueDate: '', notificationDate: '',
            snoozedUntil: '', color: '', recurrence: '', visualSize: 0,
            hasNotification: false, hasSnoozedUntil: false, hasDueDate: false,
            hasDescription: false, parentId: '', subTasksToAdd: [], commentsToAdd: []
        });
        setIsSubtasksExpanded(false);
        setIsCommentsExpanded(false);
        dispatch({ type: "TOGGLE_EDIT_MODAL", payload: { todo: null } });
        ref.current?.close();
        if (todoid) {
            navigate('/Overview');
        }

    };

    const showOrHideCompletedTasks = (event) => {
        dispatch(createFilterCanSeeAction(getfilterSetCanSeeCompletedActionType(feature), !showCompleted));
    };

    const updateDescription = () => {
        if (description) {
            if (addItemMode) {
                setAddTodo({
                    ...addTodo,
                    description: description
                });
                return;
            }

            if (todo.description !== description) {
                const json = {
                    id: todo.id,
                    hasDescription: "true",
                    description: description
                }
                editTask(json);
            }
        }

    };

    const updateIsCompleted = () => {

        if (addItemMode) {
            addTodo.IsCompleted = !isCompleted
            return;
        }

        const json = {
            id: todo.id,
            IsCompleted: !isCompleted,
        }

        editTask(json);
        closeModal();
    };

    const handleCommentChange = (event) => {
        setComment(event.target.value);
    };

    const handleSizeChange = async (sizeValue) => {

        if (addItemMode) {
            setAddTodo({
                ...addTodo,
                visualSize: sizeValue
            });
            return;
        }

        const json = {
            id: todo.id,
            visualSize: (isNullOrUndefined(sizeValue)) ? '' : sizeValue
        }
        await editTask(json);
    };

    const handleDueDateChange = (updatedDate) => {
        const dateToUse = (isNullOrUndefined(updatedDate)) ? selectedDate : updatedDate;

        if (addItemMode) {
            setAddTodo({
                ...addTodo,
                hasSnoozedUntil: "true",
                snoozedUntil: (isNullOrUndefined(dateToUse)) ? '' : dateToUse
            });
            return;
        }

        const json = {
            id: todo.id,
            hasDueDate: "true",
            dueDate: (isNullOrUndefined(dateToUse)) ? '' : dateToUse
        };
        editTask(json);
    };

    const handleNotificationDateChange = (updatedDate) => {
        const dateToUse = (isNullOrUndefined(updatedDate)) ? selectedDate : updatedDate;
        if (addItemMode) {
            setAddTodo({
                ...addTodo,
                hasNotification: "true",
                notificationDate: (isNullOrUndefined(dateToUse)) ? '' : dateToUse
            });
            return;
        }

        const json = {
            id: todo.id,
            hasNotification: "true",
            notificationDate: (isNullOrUndefined(dateToUse)) ? '' : dateToUse
        }
        editTask(json);
    };

    const handleSnoozedUntilDateChange = (updatedDate) => {
        const dateToUse = (isNullOrUndefined(updatedDate)) ? selectedDate : updatedDate;
        if (addItemMode) {
            setAddTodo({
                ...addTodo,
                hasSnoozedUntil: "true",
                snoozedUntil: (isNullOrUndefined(dateToUse)) ? '' : dateToUse
            });
            return;
        }

        const json = {
            id: todo.id,
            hasSnoozedUntil: "true",
            snoozedUntil: (isNullOrUndefined(dateToUse)) ? '' : dateToUse
        }
        editTask(json);
    };

    const handleColorChange = async () => {

        if (addItemMode) {
            setAddTodo({
                ...addTodo,
                color: todoColor
            });
            return;
        }

        const json = {
            id: todo.id,
            color: todoColor
        };
        await dispatch(changeColorOfTask(json));
    };

    const handleTitleChange = () => {

        if (title.length > 0) {
            setShowError(false);
        } else {
            setErrorMsg("* Please add a title");
            setShowError(true);
            return;
        }

        if (addItemMode) {
            setAddTodo({
                ...addTodo,
                title: title
            });
            return;
        }

        if (todo.title !== title) {
            const json = {
                id: todo.id,
                title: title
            }
            editTask(json);
        }
    };

    const openAiModal = () => {

        if (aiAssistant) {
            setShowAiModal(true);
        } else {
            setShowAiMessageModal(true);
        }

    };
    const closeAiModal = () => {
        setShowAiModal(false);
    };

    const closeMoveTo = () => {
        setShowMoveTo(false);
    };

    const handleMoveTo = () => {
        setShowMoveTo(prevState => !prevState);
    };

    const closeAcceptAiMessageModal = () => {
        setShowAiMessageModal(false);

        setShowAiModal(true);
    };

    const closeRejectAiMessageModal = () => {
        setShowAiMessageModal(false);
    };


    const editTask = async (json) => {

        if (addItemMode) return;

        const data = {
            id: json.id,
            Title: (isNullOrUndefined(json.title)) ? todo.title : json.title,
            IsCompleted: (isNullOrUndefined(json.IsCompleted)) ? todo.isCompleted.toString() : json.IsCompleted,
            HasDescription: (isNullOrUndefined(json.hasDescription)) ? false.toString() : json.hasDescription,
            Description: (isNullOrUndefined(json.description)) ? todo.description : json.description,
            HasDueDate: (isNullOrUndefined(json.hasDueDate)) ? false.toString() : json.hasDueDate,
            DueDate: (isNullOrUndefined(json.dueDate)) ? todo.dueDate : json.dueDate,
            HasHideDate: (isNullOrUndefined(json.hasHideDate)) ? false.toString() : json.hasHideDate,
            HideDate: (isNullOrUndefined(json.hideDate)) ? todo.hideDate : json.hideDate,
            VisualSize: (isNullOrUndefined(json.visualSize)) ? todo.visualSize.toString() : json.visualSize.toString(),
            HasSnoozedUntil: (isNullOrUndefined(json.hasSnoozedUntil)) ? false.toString() : json.hasSnoozedUntil,
            SnoozedUntil: (isNullOrUndefined(json.hasSnoozedUntil)) ? todo.snoozedUntil : json.snoozedUntil,
            HasNotification: (isNullOrUndefined(json.hasNotification)) ? false.toString() : json.hasNotification,
            NotificationDate: (isNullOrUndefined(json.notificationDate)) ? todo.notificationDate : json.notificationDate
        }

        await dispatch(editTaskInFirebase(data));
    };

    const handleRecurrenceChange = async (value) => {

        setRecurrence(value);
        setRecurrenceName(getRecurrenceName(value));

        if (addItemMode) {
            setAddTodo({
                ...addTodo,
                recurrence: value
            });
            return;
        }

        const json = {
            "id": todo.id,
            "detailsChanged": {
                "recurrenceChange": {
                    "recurrencePattern": {
                        "period": value
                    },
                    deleteAnyFutureIncompleteTasksIfNecessary: false
                }
            }
        }
        await dispatch(bulkEditTaskInFirebase(json));
    };

    const getRecurrenceFromServer = async (patternID) => {
        try {
            const response = await axios.get(`${import.meta.env.VITE_PUBLIC_DOMAIN}Recurrence/getRecurrencePattern/${patternID}`);
            const recurrenceData = response.data;
            if (recurrenceData && recurrenceData.pattern && recurrenceData.pattern.period !== undefined) {
                return recurrenceData.pattern.period;
            }
            return null;
        } catch (error) {
            console.error('Error fetching recurrence pattern:', error);
            return null;
        }
    };

    const getRecurrenceName = (period) => {
        switch (period.toString()) {
            case '0':
                return "Never";
            case '1': 
                return "Daily";
            case '2': 
                return "Weekly";
            case '3': 
                return "Fortnightly";
            case '4': 
                return "Monthly";
            case '5': 
                return "Bimonthly";
            case '6': 
                return "Quarterly";
            case '7': 
                return "SixMonthly";
            case '8':  
                return "Yearly";
            default:
                return "Never";
        }
         
    };


    const handleMouseOver = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    function RepeatOption({ value, label }) {
        return (
            <option value={value}>
                {label}
            </option>
        );
    };

    const openDeleteModal = () => {
        setShowDeleteModal(true);
    }

    const closeDeleteModal = () => {
        setShowDeleteModal(false);
    }

    const openMessageModal = () => {
        setShowMessageModal(true);
    }

    const closeMessageModal = () => {
        setShowMessageModal(false);
    }

    const deleteTask = async () => {
        setShowDeleteModal(false);
        const json = { id: todo.id };
        await dispatch(deleteTaskFromFirebase(json));
        closeModal();
    }

    const openRepeat = () => {
        if (dueDate === null) {
            setMessageText("A due date needs to be set before an item can repeat");
            setShowMessageModal(true);
        }
    };

    const openDateModal = (dateType) => {
        setDateType(dateType);

        switch (dateType) {
            case "hidden":
                snoozedUntil ? setModalOpenDate(snoozedUntil) : setModalOpenDate(null);
                break;
            case "notification":
                notificationDate ? setModalOpenDate(notificationDate) : setModalOpenDate(null);
                break;
            case "dueDate":
                dueDate ? setModalOpenDate(dueDate) : setModalOpenDate(null);
                break;
        }

        setShowDateModal(true);
    };

    const clearDateModal = () => {
        setShowDateModal(false);

        switch (dateType) {
            case "hidden":
                setSnoozedUntil('');
                setAddTodo({
                    ...addTodo,
                    snoozedUntil: ''
                });
                if (!addItemMode) {
                    const json = {
                        id: todo.id,
                        hasSnoozedUntil: "true",
                        snoozedUntil: ''
                    }
                    editTask(json);
                }
                
                break;
            case "notification":
                setNotificationDate('');
                setAddTodo({
                    ...addTodo,
                    notificationDate: ''
                });
                if (!addItemMode) {
                    const json = {
                        id: todo.id,
                        hasNotification: "true",
                        notificationDate: ''
                    }
                    editTask(json);
                }
                break;
            case "dueDate":
                if (recurrence && recurrence !== 0 ) {
                    setMessageText("Cannot remove due date as this item is set to repeat");
                    setShowMessageModal(true);
                    return;
                }
                setDueDate('');
                setRecurrenceName('Never');
                setAddTodo({
                    ...addTodo,
                    dueDate: ''
                });
                if (!addItemMode) {
                    const json = {
                        id: todo.id,
                        hasDueDate: "true",
                        dueDate: ''
                    }
                    editTask(json);
                }
                break;
        }
        setModalOpenDate('');
    };

    const showFolderIcon = () => {

        if (todo === "addItem") return false;

        if (todo.parent !== null && todo.children.length > 0) {
            return true;
        } else {
            return false;
        }
    }

    const closeDateModal = () => {
        setShowDateModal(false);
    };

    const saveDate = async () => {
        setShowDateModal(false);
        let updatedDate = null;
        if (selectedDate === '') {
            updatedDate = dayjs().format();
        }
        else {
            updatedDate = selectedDate;
        }
        switch (dateType) {
            case "hidden":
                setAddTodo({
                    ...addTodo,
                    snoozedUntil: updatedDate
                });
                setSnoozedUntil(updatedDate);
                if (!addItemMode) {
                    handleSnoozedUntilDateChange(updatedDate);
                }
                break;
            case "notification":
                setAddTodo({
                    ...addTodo,
                    notificationDate: updatedDate
                });
                setNotificationDate(updatedDate);
                if (!addItemMode) {
                    handleNotificationDateChange(updatedDate);
                }
                break;
            case "dueDate":
                setAddTodo({
                    ...addTodo,
                    dueDate: updatedDate
                });
                setDueDate(updatedDate);
                if (!addItemMode) {
                    handleDueDateChange(updatedDate);
                }
                break;
        }
        dispatch(setDateTime('')); 

    };

    const handleNewParentAdded = (parentId) => {
        setNewParentId(parentId);
    }

    // Keep ref pointing at the latest closeModal so the Escape handler
    // always calls the current version without needing to re-register.
    closeModalRef.current = closeModal;

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                closeModalRef.current();
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            if (todo || todoid) {
                if (!todo) {
                    if (projects && projects.length > 0) {
                        const todoItem = findByIdInTreeList(projects, todoid);
                        dispatch({ type: "TOGGLE_EDIT_MODAL", payload: { todo: todoItem } });
                        return;
                    }
                    else { return; }
                }

                setShowError(false);

                if (todo === "addItem") {
                    setTodoColor('#80C3E9');
                    setAddTodo({
                        ...addTodo,
                        color: '#80C3E9'
                    });
                    setAddItemMode(true);
                    setIsProject(false);
                    setShowCommentButton(true);
                    setShowCommentsAccordion(false);
                    setShowSubTaskButton(true);
                    setShowSubTaskAccordion(false);
                    setIsSubtasksExpanded(false);
                    setIsModalVisible(true);
                    ref.current?.show();
                    setRecurrenceName('Never');

                    return;
                }

                setAddItemMode(false);
                const todoInState = findByIdInTreeList(projects, todo.id);

                if (!todoInState) {
                    return;
                }

                if (todoInState !== todo) {
                    dispatch({ type: "TOGGLE_EDIT_MODAL", payload: { todo: todoInState } });
                    return;
                }

                handleSubTaskDisplay();
                handleCommentDisplay();

                setTodoId(todo.id);
                setIsModalVisible(true);
                setTitle(todo.title);
                getParents(todo);
                setTodoType(todo.type);
                setChildren(todo.children);
                setIsCompleted(!!todoInState.isCompleted);
                setShowMoveTo(false);
                if (todo.parent !== null) {
                    setParentRef(todo.parent.$ref);
                    setIsProject(false);
                } else {
                    setIsProject(true);
                }

                if (todo.recurrencePatternId) {
                    const period = await getRecurrenceFromServer(todo.recurrencePatternId);
                    setRecurrence(period);
                    setRecurrenceName(getRecurrenceName(period));
                }
                else {
                    setRecurrence('');
                    setRecurrenceName('Never');
                }

                setComments(todo.comments);

                if (todo.description !== null && todo.description != description) {
                    setDescription(todo.description);
                }
                if (todo.color !== null) { setTodoColor(todo.color.hexString); }
                else {
                    if (parents[0] && parents[0].color) {
                        setTodoColor(parents[0].color.hexString);
                    } else {
                        setTodoColor("#80C3E9");
                    }
                }
                setDueDate(todo.dueDate);
                setNotificationDate(todo.notificationDate);
                setSnoozedUntil(todo.snoozedUntil);
                setVisualSize(todo.visualSize);
                ref.current?.show();
            }
        }

        fetchData();
    }, [todo, projects]);

    useEffect(() => {
        if (addItemMode && aiTasks.length > 0) {

            let tasks = aiTasks.map((title, index) => ({
                id: (Math.floor(Math.random() * 9000) + 1000).toString(),
                title: title
            }));

            setAddTodo({
                ...addTodo,
                subTasksToAdd: addTodo.subTasksToAdd ? addTodo.subTasksToAdd.concat(tasks) : tasks
            });
            setShowSubTaskButton(false);
            setShowSubTaskAccordion(true);
            setIsSubtasksExpanded(true);
            countCompletedTasks(addTodo);
        }
    }, [aiTasks]);


    return (
        <>
            <AiModalComponent
                modalOpen={showAiModal}
                onClose={closeAiModal}
                todoTitle={title}
                parentId={todoId}
                newTodo={false}
                addTodo={addItemMode} />
            <AiMessageModalComponent
                modalOpen={showAiMessageModal}
                onCloseAccept={closeAcceptAiMessageModal}
                onCloseReject={closeRejectAiMessageModal} />
            <DatePickerModalComponent
                modalOpen={showDateModal}
                onClose={closeDateModal}
                onClear={clearDateModal}
                onSave={() => saveDate()}
                type={dateType}
                date={modalOpenDate}
            ></DatePickerModalComponent>
            <DeleteModal
                modalOpen={showDeleteModal}
                onClose={closeDeleteModal}
                onDelete={deleteTask}
                todoTitle={title}
                children={children.length > 0 ? true : false}
            ></DeleteModal>
            <MessageModal
                modalOpen={showMessageModal}
                onClose={closeMessageModal}
                MessageText={messageText}>
            </MessageModal>
            <div className="modal-backdrop" style={{ display: isModalVisible ? 'block' : 'none' }}></div>
            <dialog
                className="gt-modal gt-modal--task"
                ref={ref}
                aria-labelledby="task-overview-title"
                id="gt-modal-edit"
                open="">
                
                    {todo ? (
                    <div className="gt-task-overview">
                                    <EditModalHeader
                                        key={todo.id}
                                        parents={parents}
                                        closeModalRef={closeModalRef}
                                        isMobile={isMobile}
                                        projects={projects}
                                        dispatch={dispatch}
                                    />
                                    <div className="gt-task-overview__body" style={{ borderColor: todoColor }}>
                                        <div className="gt-task-overview__main">
                                            <div className="gt-task-overview__title">
                                                <input
                                                    className={isHovered || isCompleted ? "gt-task__completed gt-task-completed-background-checked" : "gt-task__completed"}
                                                    type="checkbox"
                                                    aria-label="Task completed?"
                                                    aria-checked={isCompleted}
                                                    onChange={updateIsCompleted}
                                                    checked={isCompleted}
                                                    onMouseOver={handleMouseOver}
                                                    onMouseLeave={handleMouseLeave}
                                                    style={{ background: (isHovered || isCompleted) ? (todoColor === null ? "#80C3E9" : todoColor) : 'transparent' }} />
                                    <div className="gt-task-overview__title-input">
                                        {showFolderIcon() && (
                                        <svg xmlns="http://www.w3.org/2000/svg">
                                            <use href="#globaltasks-svg-folder"></use>
                                            </svg>)}
                                                    <h2 id="task-overview-title"></h2>
                                                    <textarea
                                                        type="text"
                                                        value={title}
                                                        onChange={(e) => setTitle(e.target.value)}
                                                        placeholder="Add a Title"
                                                        onBlur={handleTitleChange}
                                                    />
                                                </div>
                                            </div>
                                            {showError && (
                                                <div className="error-body" style={{ textAlign: "left", paddingLeft: "8%" }}>
                                                    <label className="gw-checkbox__input-label error-message">
                                                        {errorMsg}
                                                    </label>
                                                </div>
                                            )}
                                            <div className="gt-task-overview__description">
                                                <svg xmlns="http://www.w3.org/2000/svg">
                                                    <use xlinkHref="#globaltasks-svg-description" />
                                                </svg>
                                                <ReactQuill
                                                    formats={["link"]}
                                                    modules={{ toolbar: [["link"]] }}
                                                    theme="snow"
                                                    className={`${textareaClass} desktop-editor`}
                                                    value={description}
                                                    onChange={handleDescriptionChange}
                                                    placeholder="Add a description"
                                                    preserveWhitespace
                                                ></ReactQuill>
                                            </div>
                                            <button className="gt-task-overview__breakdown"
                                                onClick={() => {
                                                    openAiModal();
                                                }}
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg">
                                                    <use xlinkHref="#globaltasks-svg-ai" />
                                                </svg>
                                                <p>Help me break this down</p>
                                            </button>

                                            {showSubTaskButton && (
                                                <button className="gt-task-overview__breakdown"
                                                    onClick={() => {
                                                        handleSubTaskAccordionToggle();
                                                    }}
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg">
                                                        <use xlinkHref="#globaltasks-svg-add" />
                                                    </svg>
                                                    <p>Add a task</p>
                                                </button>

                                            )}

                                            {showSubTaskAccordion && (
                                                <div className={`gt-accordion gt-accordion--mini ${isSubtasksExpanded ? 'gt-accordion--active' : ''}`} aria-expanded={isSubtasksExpanded ? "true" : "false"}>
                                                    <div className="gt-accordion__activator" >
                                                        <button className="gw-icon-button gw-icon-button--icon" onClick={handleSubtasksToggle}>
                                                            <i className="gw-icon-button__icon gw-button__icon--chevron-down" />
                                                        </button>
                                                        Tasks
                                                        {showTaskProgress && (<>                                                        <svg xmlns="http://www.w3.org/2000/svg">
                                                            <use href="#globaltasks-svg-checklist" />
                                                        </svg>
                                                        {countCompletedTasks(todo)}
                                                        </>) }
                                                        <button type="button"
                                                            className="gw-button gw-button--s1 gw-button--link"
                                                            onClick={toggleCompletedTasks}
                                                        >
                                                            {showCompletedTasks ? "Hide Completed" : "Show Completed"}
                                                        </button>
                                                    </div>
                                                    {isSubtasksExpanded && (
                                                        <div className="gt-accordion__content">
                                                            <div
                                                                className="gt-task-overview__subtasks-inner"

                                                >
                                                    {todo === "addItem" ? (
                                                        <TaskList todo={addTodo} showCompleted={showCompletedTasks} handleDragEnd={handleDragEnd} addItemMode={addItemMode} />
                                                ) : (
                                                        <TaskList todo={todo} showCompleted={showCompletedTasks} handleDragEnd={handleDragEnd} addItemMode={addItemMode} />
                                                )}
                                                    

                                                            </div>


                                                            {!isAddSubtasksShowing ? (
                                                                <button
                                                                    className="gt-task-overview__add-button"
                                                                    onClick={() => handleAddSubTaskToggle(parent.id)}
                                                                >
                                                                    <svg xmlns="http://www.w3.org/2000/svg">
                                                                        <use xlinkHref="#globaltasks-svg-add"></use>
                                                                    </svg>
                                                                    Add a task
                                                                </button>
                                                            ) : (
                                                                <div className="gt-add-task">
                                                                    <div className="gt-add-task__title">
                                                                        <textarea
                                                                            className="add-task-title"
                                                                            type="text"
                                                                            value={content}
                                                                            onChange={handleAddTaskChange}
                                                                            placeholder="Add a new task"
                                                                            onKeyDown={handleAddTaskChange}
                                                                            autoFocus={true}
                                                                        />
                                                                    </div>
                                                                    <div className="gt-add-task__controls">
                                                                        <button
                                                                            className="gw-button gw-button--s1"
                                                                            onClick={() => {
                                                                                setContent("");
                                                                                setDisableButtons(true);
                                                                                handleAddSubTaskToggle(parent.$id);
                                                                                handleSubTaskDisplay();
                                                                            }}
                                                                        >
                                                                            Cancel
                                                                        </button>
                                                                        <button
                                                                            className="gw-button gw-button--s1 gw-button--primary"
                                                                            disabled={disableButtons}
                                                                            onClick={() => {

                                                                                if (content.trim() !== "") {
                                                                                    handleAddTask(content);
                                                                                    setDisableButtons(true);
                                                                                    setContent("");

                                                                                }
                                                                            }}
                                                                        >
                                                                            Save
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            )}

                                            {showCommentsAccordion && (
                                                <div className={`gt-accordion gt-accordion--mini ${isCommentsExpanded ? 'gt-accordion--active' : ''}`} aria-expanded={isCommentsExpanded ? "true" : "false"}>
                                                    <div className="gt-accordion__activator" onClick={handleCommentsToggle}>
                                                        <button className="gw-icon-button gw-icon-button--icon">
                                                            <i className="gw-icon-button__icon gw-button__icon--chevron-down" />
                                                        </button>
                                                        Comments
                                                    </div>
                                                    {isCommentsExpanded && (
                                                        <div className="gt-accordion__content">


                                                            <Comments
                                                                handleAddComment={handleAddComment}
                                                                comments={comments}
                                                                parentId={todo.id}
                                                                handleCommentDisplay={handleCommentDisplay}
                                                                isAddCommentsShowing={isAddCommentsShowing}
                                                                handleAddCommentToggle={handleAddCommentToggle}
                                                            />
                                                        </div>
                                                    )}
                                                </div>)}
                                        </div>
                                        <div className="gt-task-overview__sidebar">
                                            <div className="gt-task-overview__accordion" aria-expanded="false">
                                                <button className="gt-task-overview__accordion-activator" onClick={handleShowDetailsToggle}>
                                                    {isShowDetailsExpanded ? 'Hide Details' : 'Show Details'}
                                                    <svg xmlns="http://www.w3.org/2000/svg">
                                                        <use xlinkHref="#globaltasks-svg-chevron-down" />
                                                    </svg>
                                                </button>
                                                <div className={`gt-task-overview__accordion-content ${isShowDetailsExpanded ? 'gt-task-overview__accordion-content--show' : ''}`}>
                                                    <label className="gt-button-field">
                                                        <div className="gt-button-field__color color-input-wrapper">
                                                            <input
                                                                type="color"
                                                                value={todoColor}
                                                                onChange={(e) => setTodoColor(e.target.value)}
                                                                onBlur={() => { handleColorChange(); }} />
                                                        </div>
                                                        Colour
                                                    </label>

                                        <button className="gt-button-field"
                                            onClick={() => {
                                                openDateModal("dueDate");
                                            }} >
                                                        <svg xmlns="http://www.w3.org/2000/svg">
                                                            <use xlinkHref="#globaltasks-svg-calendar" />
                                                        </svg>{dueDate ? dayjs(dueDate).format('ll') : 'Due date'}</button>

                                        {children.length === 0 && dueDate !== null && (
                                            <div>
                                                <select
                                                    className={`gt-button-field`}
                                                    value={recurrence}
                                                    onChange={(e) => handleRecurrenceChange(e.target.value)}
                                                    style={{ opacity: '0', position: 'absolute' }}>

                                                    <svg xmlns="http://www.w3.org/2000/svg">
                                                        <use xlinkHref="#globaltasks-svg-repeat" />
                                                    </svg>

                                                    <option value="" disabled>
                                                        Repeat tasks</option>

                                                    {/*<option value="" disabled>Repeat tasks</option>*/}
                                                    {Object.entries(RecurrencePeriodEnum).map(([key, value]) => (
                                                        <RepeatOption
                                                            key={key}
                                                            value={value}
                                                            label={key}
                                                            isSelected={value === recurrence} // Set isSelected based on recurrence
                                                        />
                                                    ))}
                                                 </select>
                                                <button className="gt-button-field"
                                                style={{ width: '100%' }}
                                                onClick={() => {
                                                    openRepeat();
                                                }}
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg">
                                                    <use xlinkHref="#globaltasks-svg-repeat" />
                                                </svg> {recurrenceName === 'Never' ? 'Repeat' : recurrenceName}
                                            </button>
                                            </div>
                                        )}

                                                    <button className="gt-button-field"
                                                        onClick={() => {
                                                            openDateModal("notification");
                                                        }}>
                                                        <svg xmlns="http://www.w3.org/2000/svg">
                                                            <use xlinkHref="#globaltasks-svg-notification" />
                                                        </svg>{notificationDate ? dayjs(notificationDate).format('ll') : 'Notification'}</button>

                                                    <div className="gt-effort">
                                                        <TaskSizeButton
                                                            taskSizeValue={addItemMode ? addTodo.visualSize : todo.visualSize}
                                                            changeSize={handleSizeChange}
                                                        />
                                                    </div>

                                                    <div className="gt-move-to">
                                                        <button className="gt-button-field"
                                                            onClick={() => { handleMoveTo() }}
                                                        >
                                                            <svg xmlns="http://www.w3.org/2000/svg">
                                                                <use xlinkHref="#globaltasks-svg-move" />
                                                            </svg>Move to
                                                        </button>
                                                        {showMoveTo && (
                                                            <MoveTaskToNewParent
                                                                onClose={closeMoveTo}
                                                                parentRef={parentRef}
                                                                taskId={todo.id}
                                                                addItemMode={addItemMode}
                                                                handleNewParentAdded={handleNewParentAdded}
                                                            />
                                                        )}
                                                    </div>

                                                    <button className="gt-button-field"
                                                        onClick={() => {
                                                            openDateModal("hidden");
                                                        }}>
                                                        <svg xmlns="http://www.w3.org/2000/svg">
                                                            <use xlinkHref="#globaltasks-svg-hide" />
                                                        </svg>{snoozedUntil ? dayjs(snoozedUntil).format('ll') : 'Hide until'}
                                                    </button>

                                                    {showCommentButton && (
                                                        <button className="gt-button-field"
                                                            onClick={() => {
                                                                handleCommentAccordionToggle();
                                                            }}
                                                        >
                                                            <svg xmlns="http://www.w3.org/2000/svg">
                                                                <use xlinkHref="#globaltasks-svg-comment" />
                                                            </svg>
                                                            Comments
                                                        </button>
                                                    )}

                                                    {!addItemMode && (
                                                        <button className="gt-button-field   gt-button-field--warning"
                                                            onClick={() => {
                                                                openDeleteModal();
                                                            }}
                                                        >
                                                            <svg xmlns="http://www.w3.org/2000/svg">
                                                                <use href="#globaltasks-svg-delete" />
                                                            </svg>Delete</button>
                                                    )}

                                                    {addItemMode && (
                                                        <button className="gw-button gw-button--primary" aria-label="Save New Task"
                                                            onClick={() => { handleAddNewTask() }}>
                                                            Save task
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            
                    ) :
                        (<LoadingScreen />
                        )}
            </dialog>
        </>
    );
};

export default EditModal;
